import './utils/storageWrapper.ts';
import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import App from './App.tsx';
import './index.css';

// Normalize legacy multi-lingual subpaths (e.g., /de/about-...) to clean paths
if (typeof window !== 'undefined') {
  const pathname = window.location.pathname;
  const match = pathname.match(/^\/(en|uk|de|es|fr)(\/.*)?$/);
  if (match) {
    const cleanPath = match[2] || '/';
    window.history.replaceState({}, '', cleanPath + window.location.search + window.location.hash);
  }
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
